import _objectSpread from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { composeEventHandlers as e } from "@radix-ui/primitive";
import { clamp as r } from "@radix-ui/number";
import { useLayoutEffect as t } from "@radix-ui/react-use-layout-effect";
import { useDirection as o } from "@radix-ui/react-use-direction";
import { useCallbackRef as n } from "@radix-ui/react-use-callback-ref";
import { useComposedRefs as l } from "@radix-ui/react-compose-refs";
import { createContextScope as i } from "@radix-ui/react-context";
import { Presence as a } from "@radix-ui/react-presence";
import { Primitive as c } from "@radix-ui/react-primitive";
import * as s from "react";
import u from "@babel/runtime/helpers/esm/extends";

var _i = i("ScrollArea"),
    _i2 = _slicedToArray(_i, 2),
    d = _i2[0],
    p = _i2[1];

export { p as createScrollAreaScope };

var _d = d("ScrollArea"),
    _d2 = _slicedToArray(_d, 2),
    f = _d2[0],
    h = _d2[1];

export var ScrollArea = /*#__PURE__*/s.forwardRef(function (e, r) {
  var t = e.__scopeScrollArea,
      _e$type = e.type,
      n = _e$type === void 0 ? "hover" : _e$type,
      _e$scrollHideDelay = e.scrollHideDelay,
      i = _e$scrollHideDelay === void 0 ? 600 : _e$scrollHideDelay,
      a = _objectWithoutProperties(e, ["__scopeScrollArea", "type", "scrollHideDelay"]),
      _s$useState = s.useState(null),
      _s$useState2 = _slicedToArray(_s$useState, 2),
      d = _s$useState2[0],
      p = _s$useState2[1],
      _s$useState3 = s.useState(null),
      _s$useState4 = _slicedToArray(_s$useState3, 2),
      h = _s$useState4[0],
      m = _s$useState4[1],
      _s$useState5 = s.useState(null),
      _s$useState6 = _slicedToArray(_s$useState5, 2),
      w = _s$useState6[0],
      b = _s$useState6[1],
      _s$useState7 = s.useState(null),
      _s$useState8 = _slicedToArray(_s$useState7, 2),
      v = _s$useState8[0],
      S = _s$useState8[1],
      _s$useState9 = s.useState(null),
      _s$useState10 = _slicedToArray(_s$useState9, 2),
      g = _s$useState10[0],
      E = _s$useState10[1],
      _s$useState11 = s.useState(0),
      _s$useState12 = _slicedToArray(_s$useState11, 2),
      C = _s$useState12[0],
      T = _s$useState12[1],
      _s$useState13 = s.useState(0),
      _s$useState14 = _slicedToArray(_s$useState13, 2),
      y = _s$useState14[0],
      A = _s$useState14[1],
      _s$useState15 = s.useState(!1),
      _s$useState16 = _slicedToArray(_s$useState15, 2),
      x = _s$useState16[0],
      R = _s$useState16[1],
      _s$useState17 = s.useState(!1),
      _s$useState18 = _slicedToArray(_s$useState17, 2),
      P = _s$useState18[0],
      L = _s$useState18[1],
      _ = l(r, function (e) {
    return p(e);
  }),
      D = o(d, a.dir);
  /*#__PURE__*/


  return s.createElement(f, {
    scope: t,
    type: n,
    dir: D,
    scrollHideDelay: i,
    scrollArea: d,
    viewport: h,
    onViewportChange: m,
    content: w,
    onContentChange: b,
    scrollbarX: v,
    onScrollbarXChange: S,
    scrollbarXEnabled: x,
    onScrollbarXEnabledChange: R,
    scrollbarY: g,
    onScrollbarYChange: E,
    scrollbarYEnabled: P,
    onScrollbarYEnabledChange: L,
    onCornerWidthChange: T,
    onCornerHeightChange: A
  }, /*#__PURE__*/s.createElement(c.div, u({}, a, {
    ref: _,
    style: _objectSpread({
      position: "relative",
      "--radix-scroll-area-corner-width": C + "px",
      "--radix-scroll-area-corner-height": y + "px"
    }, e.style)
  })));
});
/*#__PURE__*/

export var ScrollAreaViewport = /*#__PURE__*/s.forwardRef(function (e, r) {
  var t = e.__scopeScrollArea,
      o = e.children,
      n = _objectWithoutProperties(e, ["__scopeScrollArea", "children"]),
      i = h("ScrollAreaViewport", t),
      a = s.useRef(null),
      d = l(r, a, i.onViewportChange);
  /*#__PURE__*/


  return s.createElement(s.Fragment, null, /*#__PURE__*/s.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /*#__PURE__*/s.createElement(c.div, u({
    "data-radix-scroll-area-viewport": ""
  }, n, {
    ref: d,
    style: _objectSpread({
      overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
      overflowY: i.scrollbarYEnabled ? "scroll" : "hidden"
    }, e.style)
  }), /*#__PURE__*/s.createElement("div", {
    ref: i.onContentChange,
    style: {
      minWidth: "100%",
      display: "table"
    }
  }, o)));
});
/*#__PURE__*/

export var ScrollAreaScrollbar = /*#__PURE__*/s.forwardRef(function (e, r) {
  var t = e.forceMount,
      o = _objectWithoutProperties(e, ["forceMount"]),
      n = h("ScrollAreaScrollbar", e.__scopeScrollArea),
      l = n.onScrollbarXEnabledChange,
      i = n.onScrollbarYEnabledChange,
      a = "horizontal" === e.orientation;

  return s.useEffect(function () {
    return a ? l(!0) : i(!0), function () {
      a ? l(!1) : i(!1);
    };
  }, [a, l, i]), "hover" === n.type ? /*#__PURE__*/s.createElement(m, u({}, o, {
    ref: r,
    forceMount: t
  })) : "scroll" === n.type ? /*#__PURE__*/s.createElement(w, u({}, o, {
    ref: r,
    forceMount: t
  })) : "auto" === n.type ? /*#__PURE__*/s.createElement(b, u({}, o, {
    ref: r,
    forceMount: t
  })) : "always" === n.type ? /*#__PURE__*/s.createElement(v, u({}, o, {
    ref: r
  })) : null;
});
/*#__PURE__*/

var m = /*#__PURE__*/s.forwardRef(function (e, r) {
  var t = e.forceMount,
      o = _objectWithoutProperties(e, ["forceMount"]),
      n = h("ScrollAreaScrollbar", e.__scopeScrollArea),
      _s$useState19 = s.useState(!1),
      _s$useState20 = _slicedToArray(_s$useState19, 2),
      l = _s$useState20[0],
      i = _s$useState20[1];

  return s.useEffect(function () {
    var e = n.scrollArea;
    var r = 0;

    if (e) {
      var _t = function _t() {
        window.clearTimeout(r), i(!0);
      },
          _o = function _o() {
        r = window.setTimeout(function () {
          return i(!1);
        }, n.scrollHideDelay);
      };

      return e.addEventListener("pointerenter", _t), e.addEventListener("pointerleave", _o), function () {
        e.removeEventListener("pointerenter", _t), e.removeEventListener("pointerleave", _o);
      };
    }
  }, [n.scrollArea, n.scrollHideDelay]), /*#__PURE__*/s.createElement(a, {
    present: t || l
  }, /*#__PURE__*/s.createElement(b, u({
    "data-state": l ? "visible" : "hidden"
  }, o, {
    ref: r
  })));
}),
    w = /*#__PURE__*/s.forwardRef(function (r, t) {
  var o = r.forceMount,
      n = _objectWithoutProperties(r, ["forceMount"]),
      l = h("ScrollAreaScrollbar", r.__scopeScrollArea),
      i = "horizontal" === r.orientation,
      c = z(function () {
    return p("SCROLL_END");
  }, 100),
      _ref = (f = "hidden", m = {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  }, s.useReducer(function (e, r) {
    var t = m[e][r];
    return null != t ? t : e;
  }, f)),
      _ref2 = _slicedToArray(_ref, 2),
      d = _ref2[0],
      p = _ref2[1];

  var f, m;
  return s.useEffect(function () {
    if ("idle" === d) {
      var _e = window.setTimeout(function () {
        return p("HIDE");
      }, l.scrollHideDelay);

      return function () {
        return window.clearTimeout(_e);
      };
    }
  }, [d, l.scrollHideDelay, p]), s.useEffect(function () {
    var e = l.viewport,
        r = i ? "scrollLeft" : "scrollTop";

    if (e) {
      var _t2 = e[r];

      var _o2 = function _o2() {
        var o = e[r];
        _t2 !== o && (p("SCROLL"), c()), _t2 = o;
      };

      return e.addEventListener("scroll", _o2), function () {
        return e.removeEventListener("scroll", _o2);
      };
    }
  }, [l.viewport, i, p, c]), /*#__PURE__*/s.createElement(a, {
    present: o || "hidden" !== d
  }, /*#__PURE__*/s.createElement(v, u({
    "data-state": "hidden" === d ? "hidden" : "visible"
  }, n, {
    ref: t,
    onPointerEnter: e(r.onPointerEnter, function () {
      return p("POINTER_ENTER");
    }),
    onPointerLeave: e(r.onPointerLeave, function () {
      return p("POINTER_LEAVE");
    })
  })));
}),
    b = /*#__PURE__*/s.forwardRef(function (e, r) {
  var t = h("ScrollAreaScrollbar", e.__scopeScrollArea),
      o = e.forceMount,
      n = _objectWithoutProperties(e, ["forceMount"]),
      _s$useState21 = s.useState(!1),
      _s$useState22 = _slicedToArray(_s$useState21, 2),
      l = _s$useState22[0],
      i = _s$useState22[1],
      c = "horizontal" === e.orientation,
      d = z(function () {
    if (t.viewport) {
      var _e2 = t.viewport.offsetWidth < t.viewport.scrollWidth,
          _r = t.viewport.offsetHeight < t.viewport.scrollHeight;

      i(c ? _e2 : _r);
    }
  }, 10);

  return H(t.viewport, d), H(t.content, d), /*#__PURE__*/s.createElement(a, {
    present: o || l
  }, /*#__PURE__*/s.createElement(v, u({
    "data-state": l ? "visible" : "hidden"
  }, n, {
    ref: r
  })));
}),
    v = /*#__PURE__*/s.forwardRef(function (e, r) {
  var _e$orientation = e.orientation,
      t = _e$orientation === void 0 ? "vertical" : _e$orientation,
      o = _objectWithoutProperties(e, ["orientation"]),
      n = h("ScrollAreaScrollbar", e.__scopeScrollArea),
      l = s.useRef(null),
      i = s.useRef(0),
      _s$useState23 = s.useState({
    content: 0,
    viewport: 0,
    scrollbar: {
      size: 0,
      paddingStart: 0,
      paddingEnd: 0
    }
  }),
      _s$useState24 = _slicedToArray(_s$useState23, 2),
      a = _s$useState24[0],
      c = _s$useState24[1],
      d = x(a.viewport, a.content),
      p = _objectSpread({}, o, {
    sizes: a,
    onSizesChange: c,
    hasThumb: Boolean(d > 0 && d < 1),
    onThumbChange: function onThumbChange(e) {
      return l.current = e;
    },
    onThumbPointerUp: function onThumbPointerUp() {
      return i.current = 0;
    },
    onThumbPointerDown: function onThumbPointerDown(e) {
      return i.current = e;
    }
  });

  function f(e, r) {
    return function (e, r, t) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "ltr";
      var n = R(t),
          l = n / 2,
          i = r || l,
          a = n - i,
          c = t.scrollbar.paddingStart + i,
          s = t.scrollbar.size - t.scrollbar.paddingEnd - a,
          u = t.content - t.viewport;
      return L([c, s], "ltr" === o ? [0, u] : [-1 * u, 0])(e);
    }(e, i.current, a, r);
  }

  return "horizontal" === t ? /*#__PURE__*/s.createElement(S, u({}, p, {
    ref: r,
    onThumbPositionChange: function onThumbPositionChange() {
      if (n.viewport && l.current) {
        var _e3 = P(n.viewport.scrollLeft, a, n.dir);

        l.current.style.transform = "translate3d(".concat(_e3, "px, 0, 0)");
      }
    },
    onWheelScroll: function onWheelScroll(e) {
      n.viewport && (n.viewport.scrollLeft = e);
    },
    onDragScroll: function onDragScroll(e) {
      n.viewport && (n.viewport.scrollLeft = f(e, n.dir));
    }
  })) : "vertical" === t ? /*#__PURE__*/s.createElement(g, u({}, p, {
    ref: r,
    onThumbPositionChange: function onThumbPositionChange() {
      if (n.viewport && l.current) {
        var _e4 = P(n.viewport.scrollTop, a);

        l.current.style.transform = "translate3d(0, ".concat(_e4, "px, 0)");
      }
    },
    onWheelScroll: function onWheelScroll(e) {
      n.viewport && (n.viewport.scrollTop = e);
    },
    onDragScroll: function onDragScroll(e) {
      n.viewport && (n.viewport.scrollTop = f(e));
    }
  })) : null;
}),
    S = /*#__PURE__*/s.forwardRef(function (e, r) {
  var t = e.sizes,
      o = e.onSizesChange,
      n = _objectWithoutProperties(e, ["sizes", "onSizesChange"]),
      i = h("ScrollAreaScrollbar", e.__scopeScrollArea),
      _s$useState25 = s.useState(),
      _s$useState26 = _slicedToArray(_s$useState25, 2),
      a = _s$useState26[0],
      c = _s$useState26[1],
      d = s.useRef(null),
      p = l(r, d, i.onScrollbarXChange);

  return s.useEffect(function () {
    d.current && c(getComputedStyle(d.current));
  }, [d]), /*#__PURE__*/s.createElement(T, u({
    "data-orientation": "horizontal"
  }, n, {
    ref: p,
    sizes: t,
    style: _objectSpread({
      bottom: 0,
      left: "rtl" === i.dir ? "var(--radix-scroll-area-corner-width)" : 0,
      right: "ltr" === i.dir ? "var(--radix-scroll-area-corner-width)" : 0,
      "--radix-scroll-area-thumb-width": R(t) + "px"
    }, e.style),
    onThumbPointerDown: function onThumbPointerDown(r) {
      return e.onThumbPointerDown(r.x);
    },
    onDragScroll: function onDragScroll(r) {
      return e.onDragScroll(r.x);
    },
    onWheelScroll: function onWheelScroll(r, t) {
      if (i.viewport) {
        var _o3 = i.viewport.scrollLeft + r.deltaX;

        e.onWheelScroll(_o3), _(_o3, t) && r.preventDefault();
      }
    },
    onResize: function onResize() {
      d.current && i.viewport && a && o({
        content: i.viewport.scrollWidth,
        viewport: i.viewport.offsetWidth,
        scrollbar: {
          size: d.current.clientWidth,
          paddingStart: A(a.paddingLeft),
          paddingEnd: A(a.paddingRight)
        }
      });
    }
  }));
}),
    g = /*#__PURE__*/s.forwardRef(function (e, r) {
  var t = e.sizes,
      o = e.onSizesChange,
      n = _objectWithoutProperties(e, ["sizes", "onSizesChange"]),
      i = h("ScrollAreaScrollbar", e.__scopeScrollArea),
      _s$useState27 = s.useState(),
      _s$useState28 = _slicedToArray(_s$useState27, 2),
      a = _s$useState28[0],
      c = _s$useState28[1],
      d = s.useRef(null),
      p = l(r, d, i.onScrollbarYChange);

  return s.useEffect(function () {
    d.current && c(getComputedStyle(d.current));
  }, [d]), /*#__PURE__*/s.createElement(T, u({
    "data-orientation": "vertical"
  }, n, {
    ref: p,
    sizes: t,
    style: _objectSpread({
      top: 0,
      right: "ltr" === i.dir ? 0 : void 0,
      left: "rtl" === i.dir ? 0 : void 0,
      bottom: "var(--radix-scroll-area-corner-height)",
      "--radix-scroll-area-thumb-height": R(t) + "px"
    }, e.style),
    onThumbPointerDown: function onThumbPointerDown(r) {
      return e.onThumbPointerDown(r.y);
    },
    onDragScroll: function onDragScroll(r) {
      return e.onDragScroll(r.y);
    },
    onWheelScroll: function onWheelScroll(r, t) {
      if (i.viewport) {
        var _o4 = i.viewport.scrollTop + r.deltaY;

        e.onWheelScroll(_o4), _(_o4, t) && r.preventDefault();
      }
    },
    onResize: function onResize() {
      d.current && i.viewport && a && o({
        content: i.viewport.scrollHeight,
        viewport: i.viewport.offsetHeight,
        scrollbar: {
          size: d.current.clientHeight,
          paddingStart: A(a.paddingTop),
          paddingEnd: A(a.paddingBottom)
        }
      });
    }
  }));
}),
    _d3 = d("ScrollAreaScrollbar"),
    _d4 = _slicedToArray(_d3, 2),
    E = _d4[0],
    C = _d4[1],
    T = /*#__PURE__*/s.forwardRef(function (r, t) {
  var o = r.__scopeScrollArea,
      i = r.sizes,
      a = r.hasThumb,
      d = r.onThumbChange,
      p = r.onThumbPointerUp,
      f = r.onThumbPointerDown,
      m = r.onThumbPositionChange,
      w = r.onDragScroll,
      b = r.onWheelScroll,
      v = r.onResize,
      S = _objectWithoutProperties(r, ["__scopeScrollArea", "sizes", "hasThumb", "onThumbChange", "onThumbPointerUp", "onThumbPointerDown", "onThumbPositionChange", "onDragScroll", "onWheelScroll", "onResize"]),
      g = h("ScrollAreaScrollbar", o),
      _s$useState29 = s.useState(null),
      _s$useState30 = _slicedToArray(_s$useState29, 2),
      C = _s$useState30[0],
      T = _s$useState30[1],
      y = l(t, function (e) {
    return T(e);
  }),
      A = s.useRef(null),
      x = s.useRef(""),
      R = g.viewport,
      P = i.content - i.viewport,
      L = n(b),
      _ = n(m),
      D = z(v, 10);

  function W(e) {
    if (A.current) {
      var _r2 = e.clientX - A.current.left,
          _t3 = e.clientY - A.current.top;

      w({
        x: _r2,
        y: _t3
      });
    }
  }

  return s.useEffect(function () {
    var e = function e(_e5) {
      var r = _e5.target;
      (null == C ? void 0 : C.contains(r)) && L(_e5, P);
    };

    return document.addEventListener("wheel", e, {
      passive: !1
    }), function () {
      return document.removeEventListener("wheel", e, {
        passive: !1
      });
    };
  }, [R, C, P, L]), s.useEffect(_, [i, _]), H(C, D), H(g.content, D), /*#__PURE__*/s.createElement(E, {
    scope: o,
    scrollbar: C,
    hasThumb: a,
    onThumbChange: n(d),
    onThumbPointerUp: n(p),
    onThumbPositionChange: _,
    onThumbPointerDown: n(f)
  }, /*#__PURE__*/s.createElement(c.div, u({}, S, {
    ref: y,
    style: _objectSpread({
      position: "absolute"
    }, S.style),
    onPointerDown: e(r.onPointerDown, function (e) {
      if (0 === e.button) {
        e.target.setPointerCapture(e.pointerId), A.current = C.getBoundingClientRect(), x.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", W(e);
      }
    }),
    onPointerMove: e(r.onPointerMove, W),
    onPointerUp: e(r.onPointerUp, function (e) {
      e.target.releasePointerCapture(e.pointerId), document.body.style.webkitUserSelect = x.current, A.current = null;
    })
  })));
});

export var ScrollAreaThumb = /*#__PURE__*/s.forwardRef(function (r, t) {
  var o = r.__scopeScrollArea,
      n = r.style,
      i = _objectWithoutProperties(r, ["__scopeScrollArea", "style"]),
      a = h("ScrollbarThumb", o),
      d = C("ScrollbarThumb", o),
      p = d.onThumbPositionChange,
      f = l(t, function (e) {
    return d.onThumbChange(e);
  }),
      m = s.useRef(),
      w = z(function () {
    m.current && (m.current(), m.current = void 0);
  }, 100);

  return s.useEffect(function () {
    var e = a.viewport;

    if (e) {
      var _r3 = function _r3() {
        if (w(), !m.current) {
          var _r4 = D(e, p);

          m.current = _r4, p();
        }
      };

      return p(), e.addEventListener("scroll", _r3), function () {
        return e.removeEventListener("scroll", _r3);
      };
    }
  }, [a.viewport, w, p]), d.hasThumb ? /*#__PURE__*/s.createElement(c.div, u({}, i, {
    ref: f,
    style: _objectSpread({
      width: "var(--radix-scroll-area-thumb-width)",
      height: "var(--radix-scroll-area-thumb-height)"
    }, n),
    onPointerDownCapture: e(r.onPointerDownCapture, function (e) {
      var r = e.target.getBoundingClientRect(),
          t = e.clientX - r.left,
          o = e.clientY - r.top;
      d.onThumbPointerDown({
        x: t,
        y: o
      });
    }),
    onPointerUp: e(r.onPointerUp, d.onThumbPointerUp)
  })) : null;
});
/*#__PURE__*/

export var ScrollAreaCorner = /*#__PURE__*/s.forwardRef(function (e, r) {
  var t = h("ScrollAreaCorner", e.__scopeScrollArea),
      o = Boolean(t.scrollbarX && t.scrollbarY);
  return "scroll" !== t.type && o ? /*#__PURE__*/s.createElement(y, u({}, e, {
    ref: r
  })) : null;
});
/*#__PURE__*/

var y = /*#__PURE__*/s.forwardRef(function (e, r) {
  var t = e.__scopeScrollArea,
      o = _objectWithoutProperties(e, ["__scopeScrollArea"]),
      n = h("ScrollAreaCorner", t),
      _s$useState31 = s.useState(0),
      _s$useState32 = _slicedToArray(_s$useState31, 2),
      l = _s$useState32[0],
      i = _s$useState32[1],
      _s$useState33 = s.useState(0),
      _s$useState34 = _slicedToArray(_s$useState33, 2),
      a = _s$useState34[0],
      d = _s$useState34[1],
      p = Boolean(l && a);

  return H(n.scrollbarX, function () {
    var e;
    var r = (null === (e = n.scrollbarX) || void 0 === e ? void 0 : e.offsetHeight) || 0;
    n.onCornerHeightChange(r), d(r);
  }), H(n.scrollbarY, function () {
    var e;
    var r = (null === (e = n.scrollbarY) || void 0 === e ? void 0 : e.offsetWidth) || 0;
    n.onCornerWidthChange(r), i(r);
  }), p ? /*#__PURE__*/s.createElement(c.div, u({}, o, {
    ref: r,
    style: _objectSpread({
      width: l,
      height: a,
      position: "absolute",
      right: "ltr" === n.dir ? 0 : void 0,
      left: "rtl" === n.dir ? 0 : void 0,
      bottom: 0
    }, e.style)
  })) : null;
});

function A(e) {
  return e ? parseInt(e, 10) : 0;
}

function x(e, r) {
  var t = e / r;
  return isNaN(t) ? 0 : t;
}

function R(e) {
  var r = x(e.viewport, e.content),
      t = e.scrollbar.paddingStart + e.scrollbar.paddingEnd,
      o = (e.scrollbar.size - t) * r;
  return Math.max(o, 18);
}

function P(e, t) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ltr";
  var n = R(t),
      l = t.scrollbar.paddingStart + t.scrollbar.paddingEnd,
      i = t.scrollbar.size - l,
      a = t.content - t.viewport,
      c = i - n,
      s = r(e, "ltr" === o ? [0, a] : [-1 * a, 0]);
  return L([0, a], [0, c])(s);
}

function L(e, r) {
  return function (t) {
    if (e[0] === e[1] || r[0] === r[1]) return r[0];
    var o = (r[1] - r[0]) / (e[1] - e[0]);
    return r[0] + o * (t - e[0]);
  };
}

function _(e, r) {
  return e > 0 && e < r;
}

var D = function D(e) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var t = {
    left: e.scrollLeft,
    top: e.scrollTop
  },
      o = 0;
  return function n() {
    var l = {
      left: e.scrollLeft,
      top: e.scrollTop
    },
        i = t.left !== l.left,
        a = t.top !== l.top;
    (i || a) && r(), t = l, o = window.requestAnimationFrame(n);
  }(), function () {
    return window.cancelAnimationFrame(o);
  };
};

function z(e, r) {
  var t = n(e),
      o = s.useRef(0);
  return s.useEffect(function () {
    return function () {
      return window.clearTimeout(o.current);
    };
  }, []), s.useCallback(function () {
    window.clearTimeout(o.current), o.current = window.setTimeout(t, r);
  }, [t, r]);
}

function H(e, r) {
  var o = n(r);
  t(function () {
    var r = 0;

    if (e) {
      var _t4 = new ResizeObserver(function () {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(o);
      });

      return _t4.observe(e), function () {
        window.cancelAnimationFrame(r), _t4.unobserve(e);
      };
    }
  }, [e, o]);
}

export var Root = ScrollArea;
export var Viewport = ScrollAreaViewport;
export var Scrollbar = ScrollAreaScrollbar;
export var Thumb = ScrollAreaThumb;
export var Corner = ScrollAreaCorner;